if(!customElements.get('product-main')) {
  class ProductMain extends HTMLElement {
    static instanceCount = 0;

    constructor() {
      super();
      this.sectionId = this.dataset.section + '-' + ProductMain.instanceCount++; // for Unique product component IDs
      this.productData = JSON.parse(this.querySelector('[type="application/json"][data-product-json]').textContent);
      this.fillProductData();
      this.variantsElement = this.querySelector('product-variants');
      this.sellingPlanElement = this.querySelector('product-selling-plan');
      this.quantityElement = this.querySelector('.quantity-input');
      this.badgesSale = this.querySelectorAll('.badge.sale');
      this.badgesSoldOut = this.querySelectorAll('.badge.sold-out');
      this.variantTitleElements = this.querySelectorAll('[data-variant-title]');
      this.optionValues = {}
      const requiredOptionsSetting = ([] || []).concat(this.dataset.manualSelect ? this.dataset.manualSelect.split(',') : []).map(x=>x.trim());
      const requiredOptionsSettingUnique = [...new Set(requiredOptionsSetting)];
      this.requiredOptions = this.productData.options_with_values.filter(x=>(requiredOptionsSettingUnique.indexOf(x.name)>-1 || requiredOptionsSettingUnique.indexOf('*')>-1) && x.values.length>1).map(x=>x.name);
      if (this.requiredOptions.length > 0) {
        this.setAttribute('data-required', 'true');
      }
      if (this.quantityElement) {
        this.quantityElement.addEventListener('change', this.onQuantityElementChange.bind(this));
      }
      this.addEventListener('variantChange', this.onVariantChange.bind(this));

      var productGallery = this.querySelector('product-gallery');
      if (productGallery) {
        productGallery.querySelectorAll('.media-wrap.image-wrap.has-hover-bg').forEach((mediaWrap)=>{
          if (!mediaWrap.querySelector('.img.hover-bg')) return;
          var hoverActive = false;
          mediaWrap.addEventListener('mouseleave', ()=>{
            if (hoverActive) {
              hoverActive = false;
              mediaWrap.classList.remove('hover');
            }
          });
          mediaWrap.addEventListener('mousemove', (e)=>{
            var bounds = mediaWrap.getBoundingClientRect();
            if (e.clientY > bounds.top && e.clientY < bounds.bottom && e.clientX > bounds.left && e.clientX < bounds.right) {
              if (!hoverActive) {
                hoverActive = true;
                mediaWrap.classList.add('hover');
              }
            } else if (hoverActive) {
              hoverActive = false;
              mediaWrap.classList.remove('hover');
            }
          });
        });
      }

      
}

    fillProductData() {
      const isMerge = this.productData.is_product_merge;
      if (isMerge) {
        this.productData.options_with_values.forEach((x,index)=>{
          for (let v of  this.productData.variants) {
            let option = x.values.find(y=>y.value==v.options[index]);
            if (!option) {
              option = {value: v.options[index], available: v.available};
              x.values.push(option);
            }
            option.available = option.available || v.available;
          }
        });
        this.sortMergeOptionValues();
        this.applyStoredMergeSwatchOrder();
      }if (this.productData.is_product_main) {
        this.productData.media = Array.from(this.querySelectorAll('product-gallery [data-media-id]')).map((media)=>{
          return {
            "alt": media.getAttribute('data-media-alt') || '',
            "id": media.getAttribute('data-media-id'),
            "product_id": media.getAttribute('data-product-id')
          };
        });
      }

    }

    normalizeFilterValue(value) {
      return (value || '').toString().trim().toLowerCase();
    }

    mediaMatchesVariant(mediaAlt, variant) {
      if (!mediaAlt || !mediaAlt.toString().trim()) {
        return true;
      }
      if (!variant) {
        return false;
      }
      var optionsWithValues = this.productData.options_with_values || [];
      var filters = mediaAlt.split(';');
      for (var i = 0; i < filters.length; i++) {
        var segment = filters[i].trim();
        if (!segment) continue;
        var colonIdx = segment.indexOf(':');
        if (colonIdx === -1) continue;
        var key = segment.slice(0, colonIdx).trim();
        var valuesStr = segment.slice(colonIdx + 1).trim();
        if (!key || !valuesStr) continue;
        var optionIndex = optionsWithValues.findIndex((option)=>{
          return this.normalizeFilterValue(option.name) === this.normalizeFilterValue(key);
        });
        if (optionIndex < 0) continue;
        if (!variant.options || optionIndex >= variant.options.length) {
          return false;
        }
        var variantValue = this.normalizeFilterValue(variant.options[optionIndex]);
        var matched = valuesStr.split(',').some((value)=>{
          return variantValue === this.normalizeFilterValue(value);
        });
        if (!matched) {
          return false;
        }
      }
      return true;
    }

    sortMergeOptionValues() {
      if (!this.productData.is_product_merge || !this.productData.merge_product_ids?.length) {
        return;
      }
      var productOrder = this.productData.merge_product_ids;
      var variants = this.productData.variants;

      this.productData.options_with_values.forEach((option, optionIndex) => {
        var valueMap = new Map();
        option.values.forEach(function(v) {
          valueMap.set(v.value, v);
        });

        var orderedValues = [];
        var seen = new Set();

        productOrder.forEach(function(productId) {
          variants.filter(function(v) {
            return v.product_id == productId;
          }).forEach(function(variant) {
            var val = variant.options[optionIndex];
            if (val != null && !seen.has(val) && valueMap.has(val)) {
              seen.add(val);
              orderedValues.push(valueMap.get(val));
            }
          });
        });

        option.values.forEach(function(v) {
          if (!seen.has(v.value)) {
            orderedValues.push(v);
          }
        });

        option.values = orderedValues;
      });
    }

    applyStoredMergeSwatchOrder() {
      if (!this.productData.is_product_merge || !this.productData.merge_group_key) {
        return;
      }
      var storageKey = 'merge_swatch_order_' + this.productData.merge_group_key;
      var stored = sessionStorage.getItem(storageKey);
      if (!stored) {
        return;
      }
      try {
        var storedOrder = JSON.parse(stored);
        this.productData.options_with_values.forEach(function(option, index) {
          if (!storedOrder[index] || !Array.isArray(storedOrder[index])) {
            return;
          }
          var valueMap = new Map(option.values.map(function(v) {
            return [v.value, v];
          }));
          var orderedValues = [];
          storedOrder[index].forEach(function(value) {
            if (valueMap.has(value)) {
              orderedValues.push(valueMap.get(value));
              valueMap.delete(value);
            }
          });
          valueMap.forEach(function(v) {
            orderedValues.push(v);
          });
          option.values = orderedValues;
        });
      } catch (err) {
        // ignore invalid stored order
      }
      sessionStorage.removeItem(storageKey);
    }

    saveMergeSwatchOrder() {
      if (!this.productData.is_product_merge || !this.productData.merge_group_key) {
        return;
      }
      var order = this.productData.options_with_values.map(function(opt) {
        return opt.values.map(function(v) {
          return v.value;
        });
      });
      sessionStorage.setItem('merge_swatch_order_' + this.productData.merge_group_key, JSON.stringify(order));
    }

    isSwatchSelected() {
      return this.requiredOptions.length == 0 || this.requiredOptions.length < this.productData.options_with_values.length;
    }

    required(option, newValue) {
      var ix = this.requiredOptions.indexOf(option);
      if (typeof(newValue)!='undefined') {
        if (ix > -1) {
          this.requiredOptions.splice(ix, 1);
          if (this.requiredOptions.length == 0) {
            this.setAttribute('data-required', 'false');
          }
          return false;
        }
      }
      return ix > -1;
    }

    getCurrentVariant() {
      return this.variantsElement.getCurrentVariant();
    }
    getCurrentPlan() {
      return this.sellingPlanElement?.getCurrentPlan();
    }
    getQuantity() {
      return this.quantityElement ? this.quantityElement.value : 1;
    }
    getQuantityInVariantName() {
      var variant = this.getCurrentVariant();
      if (!variant || !variant.title) {
        return 1;
      }
      var bag = variant.title.match(/(\d+)\s*Bag/i);
      if (bag) {
        return parseInt(bag[1], 10) || 1;
      }
      var box = variant.title.match(/(\d+)\s*Box/i);
      if (box) {
        return parseInt(box[1], 10) || 1;
      }
      return 1;
    }
    onQuantityElementChange() {
      this.dispatchEvent(new CustomEvent('quantityChange', {detail: {"quantity":this.getQuantity()}}));
    }
    onVariantChange() {
      // Lightweight update of elements that not worth creating their own components
      var variant = event.detail.variant;
      this.variantTitleElements.forEach(element=>{
        element.innerHTML = variant.title;
      });
      this.badgesSale.forEach(element=>{
        var sale = '';
        var percent = Math.floor((1 - variant.price / variant.compare_at_price) * 100);
        if (percent > 0) {
          sale = element.dataset.msgtpl.replace('[percent]', percent);
        }
        element.style.display = variant.available && sale ? '' : 'none';
        element.innerHTML = sale;
      });
      this.badgesSoldOut.forEach(element=>{
        element.style.display = variant.available ? 'none' : '';
      });}}
  customElements.define('product-main', ProductMain);

  class ComponentProductCardAtc extends ProductMain {
    constructor() {
      super()
      this.swatches = this.querySelector('.swatch-group')
      this.addEventListener('variantChange', this.onVariantChange.bind(this));
      this.defaultImage = this.querySelector('.img.main').getAttribute('data-srcset');
      this.currentImageUrl = '';
      this.imageObserver = null;
      this.clickOutHandler = null;
      let imageContainer = this.querySelector('.image-container');
      if (imageContainer && imageContainer.querySelector('.img.hover-bg')) {
        let hover = false;
        this.addEventListener('mouseleave', (e)=>{
          hover && (hover=false,imageContainer.classList.remove("hover"));
        });
        this.addEventListener('mousemove', (e)=>{
          let bounds = imageContainer.getBoundingClientRect();
          if (e.y>bounds.top && e.y<bounds.bottom && e.x>bounds.left && e.x<bounds.right) {
            hover || (hover=true,imageContainer.classList.add("hover"))
          } else {
            hover && (hover=false,imageContainer.classList.remove("hover"));
          }
        });
      }
      
      this.optionsButton = this.querySelector('.atc-options');
      if (this.optionsButton) {
        this.optionsButton.addEventListener('click', this.openOptions.bind(this));
        
      }


      this.quickViewBtn = this.querySelector('.quick-view-trigger')
      if(this.quickViewBtn) {
        this.quickViewBtn.addEventListener('click', this.openQuickView.bind(this));
      }

      var self = this;
      if (self.classList.contains('colors-out')) {
        setTimeout(function() { //workaround on ajax call, the following code mistakenly inits ProductSwatch before ProductVariants
          var origSwatches = self.querySelector('product-swatch.color-swatches');
          if (origSwatches) {
            //need to duplicate the whole product-variants component
            var pv = origSwatches.closest('product-variants');
            var tag = pv.outerHTML.replace('name="id"', '');
            var wrapper = document.createElement('div');
            wrapper.style.display = 'none';
            //must insert as Element, not HTML, otherwise the component would be reconstructed
            self.querySelector('add-to-cart-form').insertAdjacentElement('beforebegin', wrapper);
            tag = tag.replace('<product-swatch', '<product-swatch data-trim-options-limit="0"');
            wrapper.innerHTML = tag;
            //move the swatches inside the add-to-cart-form component to use existing css.
            self.querySelector('add-to-cart-form').insertAdjacentElement('afterbegin', wrapper.querySelector('product-swatch.color-swatches'));
          }
        }, 10);
      }
      if (window.LinkPrefetch && window.LinkPrefetch.addHoverListener) {
        window.LinkPrefetch.addHoverListener(this);
      }
    }

    // Added to match colors on product cards loaded through ajax, probably not needed for main product sections
    copySchemeFrom(el) {
      var lookForClasses = ['scheme','color-scheme-1','color-scheme-3','color-scheme-2de4938b-d68e-46fd-8813-5da3514abffe','color-scheme-2cc23e44-0f10-4ab4-bb15-ad3c2664154a', 'same-scheme-true', 'same-scheme-false'];
      lookForClasses.forEach(name=>{
        if (el.classList.contains(name)) {
          this.classList.add(name);
        } else {
          this.classList.remove(name);
        }
      })
      
    }

    openOptions(e) {
      e.preventDefault()
      const currentVariant = this.getCurrentVariant();
      if (currentVariant && currentVariant.available) {
        const inputs = this.querySelectorAll(
          'input:not([type="hidden"]):not([type="button"]):not([type="submit"]):not([type="reset"]), textarea, select'
        );
        if (inputs.length==0) {
          this.querySelector('.btn.add').click();
          return;
        }
      }
      
      if (this.querySelector('.atc-options-wrapper').classList.contains('open')) {
        return;
      }
      var container = this.querySelector('.atc-options-wrapper form');
      this.querySelector('.atc-options-wrapper').classList.add('open');
      $s.trapFocus(container);
      var self = this;
      if (!this.clickOutHandler) {
        this.querySelector('.close').addEventListener('click', this.closeOptions.bind(this));
      }
      this.clickOutHandler = function(evt) {
        if(container !== evt.target && !container.contains(evt.target)) {
          self.closeOptions.bind(self)();
        }
      }
      document.addEventListener('mousedown', this.clickOutHandler);
    }
    closeOptions() {
      this.querySelector('.atc-options-wrapper').classList.remove('open');
      document.removeEventListener('mousedown', this.clickOutHandler);
      $s.removeTrapFocus();
    }

    openQuickView(e) {
      e.preventDefault()
      $s.showLoadingOverlay();
      var qvUrl = this.quickViewBtn.dataset.url;
      $s.get({
        url: qvUrl,
        success: (html)=>{
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var section = doc.querySelector('.product-main-element').closest('.shopify-section');
          var enhancedDescription = section.querySelector('.enhanced-description');
          if (enhancedDescription && enhancedDescription.querySelector('.expandable-default-open')) {
            enhancedDescription.querySelector('.accordion.open').classList.remove('open');
            enhancedDescription.querySelector('[aria-expanded=true]').ariaExpanded = false;
            enhancedDescription.querySelector('.expandable-default-open').classList.remove('expandable-default-open');
          }
          $s.openModal(section, 'product-quick-view');
          $s.globalEval(section);
        },
        always: (html)=>{
          $s.hideLoadingOverlay();
        }
      })
    }

    onVariantChange(event) {
      super.onVariantChange(event);
      var variant = event.detail.variant;
      var image = variant.featured_media && super.isSwatchSelected() ? variant.featured_media : null;
      var img = this.querySelector('.img.main');
      var width = Math.ceil(img.width / 100) * 100;
      if (image && img.classList.contains('under-video')) {
        this.querySelector('.video-wrap').remove();
        img.classList.remove('under-video');
      }

      if (img.classList.contains('lazyload')) {
        img.setAttribute('data-srcset', image ? $s.buildImgSrcset(image.src, image.width) : this.defaultImage);
      } else {
        this.currentImageUrl = image ? $s.buildImgSrcset(image.src, image.width) : this.defaultImage;
        if (!this.imageObserver) {
          if (!img.classList.contains('lazyloaded')) {
            this.imageObserver = new MutationObserver(mutations => {
              if (img.classList.contains('lazyloaded')) {
                this.imageObserver.disconnect();
                this.imageObserver = null;
                img.setAttribute('srcset', this.currentImageUrl);
              }
            });
            var config = { attributes: true, attributeFilter: ['class']};
            this.imageObserver.observe(img, config);
          } else {
            img.setAttribute('srcset', this.currentImageUrl);
          }
        }
      }

      // Update urls to variant
      var links = this.querySelectorAll('.product-card-url[href]');
      if (links.length > 0 && this.requiredOptions.length < this.productData.options_with_values.length) {
        var productUrl = new URL(links[0].getAttribute('href'), location.origin);
        productUrl.searchParams.set('variant', variant.id);
        links.forEach(link=>{
          link.setAttribute('href', productUrl.toString());
        });
        if (this.quickViewBtn) {
          this.quickViewBtn.dataset.url = productUrl.toString();
        }
      }
    }
  }
  customElements.define('product-card-atc', ComponentProductCardAtc);
}

if(!customElements.get('product-buttons')) {
  class ProductButtons extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.dynamicButtons = this.querySelector('.shopify-payment-button');
      this.mainAddButton = this.mainElement.querySelector('.btn.add');
      this.button = this.querySelector('.btn.add');
      var atcForm = this.mainElement.querySelector('add-to-cart-form');
      this.walmartOnly = atcForm && atcForm.dataset.walmartLink === 'true' && atcForm.dataset.walmartUrl;
      this.walmartDual = atcForm && atcForm.dataset.walmartDualAtc === 'true' && atcForm.dataset.walmartUrl;
      this.walmartLink = this.walmartOnly;
      if (this.button != this.mainAddButton) {
        this.button.addEventListener('click', (event)=>{
          event.preventDefault();
          event.stopImmediatePropagation();
          this.mainAddButton.click();
        });
      }

      this.mainElement.addEventListener('variantChange', (e)=>{
        var requiredBtn = this.querySelector('.btn.selection-required');
        var walmartBtn = this.querySelector('.btn-walmart-link');
        if (this.required() && requiredBtn) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }
          requiredBtn.style.display = '';
          requiredBtn.innerHTML = this.requiredMessage;
          if (walmartBtn) {
            walmartBtn.style.display = this.walmartDual ? '' : 'none';
          }
        } else if(e.detail.variant && (e.detail.variant.available || this.walmartOnly)) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.remove('hide');
          }
          this.querySelector('.btn.add').style.display = '';
          this.querySelector('.sold-out-message').style.display = 'none';
          if (requiredBtn) requiredBtn.style.display = 'none';
          if (walmartBtn) {
            walmartBtn.style.display = this.walmartDual ? '' : 'none';
          }
      	} else {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }
          this.querySelector('.btn.add').style.display = 'none';
          this.querySelector('.sold-out-message').style.display = '';
          if (requiredBtn) requiredBtn.style.display = 'none';
          if (walmartBtn) {
            walmartBtn.style.display = this.walmartDual ? '' : 'none';
          }
      	}
      });
    }

    required() {
      if (this.mainElement.requiredOptions.length > 0) {
        this.requiredMessage = '';
        var label = this.mainElement.requiredOptions[0];
        var firstLetter = label[0].toLowerCase();
        var prep = 'aeiou'.indexOf(firstLetter)>-1 ? 'an' : 'a'; //english support only
        this.requiredMessage = lngg.product_main__select_option_label.replace('Select a ', 'Select ' + prep + ' ').replace(new RegExp(/{{ *option_name *}}/), label);
        return true;
      }
      return false;
    }
  }
  customElements.define('product-buttons', ProductButtons);
}

if(!customElements.get('product-sku')) {
  class ProductSKU extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');

      this.mainElement.addEventListener('variantChange', (e)=>{
      	if(e.detail.variant) {
          if(e.detail.variant.sku) {
            this.closest('.module').style.display = 'block';
            this.innerHTML = e.detail.variant.sku;
          }else{
            this.closest('.module').style.display = 'none';
          }
      	}
      });
    }
  }
  customElements.define('product-sku', ProductSKU);
}

if(!customElements.get('product-gallery') && !customElements.get('product-thumbs')) {
  class ProductMedia extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.itemsWrapper = this.querySelector('.items-wrapper');
      this.desktopStyle = this.dataset.desktop;
      this.desktopOrientation = this.dataset.desktopOrientation;
      this.mobileStyle = this.dataset.mobile;
      this.slider = false;

      this.mainElement.addEventListener('variantChange', this.onVariantChange.bind(this))
      window.addEventListener('mediaChange', this.onMediaChange.bind(this))
      setTimeout(()=>{
        this.onMediaChange();
      }, 10);
    }

    filterMedia(variant) {
      var self = this;
      if (!this.mainElement.productData.media) {
        return;
      }
      var variantProductId = variant && variant.product_id ? String(variant.product_id) : String(this.mainElement.productData.product_id);
      this.mainElement.productData.media.forEach(function(media) {
        var el = self.querySelector('[data-media-id="'+media.id+'"]');
        if (!el) {
          return;
        }
        if (media.product_id && String(media.product_id) !== variantProductId) {
          el.style.display = 'none';
          return;
        }
        var show = self.mainElement.mediaMatchesVariant(media.alt, variant);
        el.style.display = show ? '' : 'none';
      });
      if (this.slider) {
        this.slider.refresh();
      }
    }

    onVariantChange() {
    }

    onMediaChange() {
    }

    initSlider() {
    }

    removeSlider() {
      if(this.slider) {
        this.slider.destroy();
        this.slider = false;
        this.classList.remove('keen');
        this.itemsWrapper.classList.remove('keen-slider');
        this.querySelectorAll('.media-wrap, .thumb-wrap').forEach((slide)=>{
          slide.classList.remove('keen-slider-slide')
        });
      }
    }

    showItem(mediaId, animate=true) {
      if(this.slider) {
        var index = Array.from(this.itemsWrapper.querySelectorAll('.media-wrap, .thumb-wrap'))
          .filter(x=>$s.isVisible(x)).findIndex(x=>x.dataset.mediaId==mediaId);
        if(animate) {
          this.slider.moveToSlideRelative(index, true);
        } else {
          this.slider.moveToSlideRelative(index, true, 0);
        }
      }
    }
  }
  
  class ProductGallery extends ProductMedia {
    constructor() {
      super();
      this.videoAutoplay = this.dataset.videoAutoplay;
      this.autoplayOptionsElement = this.videoAutoplay ? this.querySelector('.autoplay-options') : null;
      this.autoplayCheck = this.autoplayOptionsElement ? this.autoplayOptionsElement.querySelector('input') : null;
      this.itemsPerViewMobile = this.dataset.itemsPerViewMobile ? this.dataset.itemsPerViewMobile/1 : 1;
      if (this.autoplayCheck) {
        this.autoplayCheck.addEventListener('change', (e)=>{
          Cookies.set('autoplay', e.target.checked ? 'enabled' : 'disabled');
        });
        this.autoplayCheck.checked = Cookies.get('autoplay') !== 'disabled';
      }

      if(!this.closest('.tingle-modal') && this.dataset.galleryClickZoom !== 'false') {
        this.querySelectorAll('[data-file]').forEach((media)=>{
          media.addEventListener('click', (e)=>{
            var visibleItems = [];
            this.querySelectorAll('[data-media-id]').forEach((obj)=>{
              if($s.isVisible(obj)) {
                let element  = obj.querySelector('[data-file], video, iframe');
                if(element) {
                  visibleItems.push(element);
                }
              }
            });
            $s.photoSwipe(visibleItems, media);
          });
        });
        //3D Models
        this.querySelectorAll('[data-media-id].model-wrap').forEach((model)=>{
          model.addEventListener('click', (e)=>{
            $s.photoSwipe([model.querySelector('template').content.firstElementChild]);         
          });
        });
      }
    }

    getTargetMediaId(variant) {
      if (!variant || !this.mainElement.isSwatchSelected()) {
        return null;
      }
      if (variant.featured_media) {
        var featuredEl = this.querySelector('[data-media-id="'+variant.featured_media.id+'"]');
        if (featuredEl && featuredEl.style.display !== 'none' && $s.isVisible(featuredEl)) {
          return String(variant.featured_media.id);
        }
      }
      var variantProductId = variant.product_id ? String(variant.product_id) : String(this.mainElement.productData.product_id);
      var taggedMedia = this.mainElement.productData.media.find((media)=>{
        if (media.product_id && String(media.product_id) !== variantProductId) {
          return false;
        }
        if (!media.alt || media.alt.indexOf(':') === -1) {
          return false;
        }
        return this.mainElement.mediaMatchesVariant(media.alt, variant);
      });
      if (taggedMedia) {
        var taggedEl = this.querySelector('[data-media-id="'+taggedMedia.id+'"]');
        if (taggedEl && taggedEl.style.display !== 'none' && $s.isVisible(taggedEl)) {
          return String(taggedMedia.id);
        }
      }
      var firstVisible = Array.from(this.itemsWrapper.querySelectorAll('.media-wrap')).find((el)=>{
        return el.style.display !== 'none' && $s.isVisible(el);
      });
      return firstVisible ? firstVisible.dataset.mediaId : null;
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      var animate = e.detail.animate;
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant);
        var targetMediaId = this.getTargetMediaId(variant);
        if (targetMediaId) {
          this.showItem(targetMediaId, animate);
        }
        this.syncGallerySlider();
      }
    }

    getVisibleSlideCount() {
      return Array.from(this.itemsWrapper.querySelectorAll('.media-wrap')).filter(function(el) {
        return el.style.display !== 'none';
      }).length;
    }

    toggleGalleryNav(show) {
      var nav = this.querySelector('.keen-arrows');
      var dotsWrap = this.querySelector('.keen-dots');
      if (dotsWrap) {
        dotsWrap = dotsWrap.closest('.container');
      }
      if (nav) {
        nav.style.display = show ? '' : 'none';
      }
      if (dotsWrap) {
        dotsWrap.style.display = show ? '' : 'none';
      }
    }

    syncGallerySlider() {
      var slideCount = this.getVisibleSlideCount();
      this.itemsWrapper.querySelectorAll('.media-wrap').forEach(function(slide) {
        if (slide.style.display === 'none') {
          slide.classList.remove('keen-slider-slide');
        } else {
          slide.classList.add('keen-slider-slide');
        }
      });
      if (slideCount <= 1) {
        this.removeSlider();
        this.toggleGalleryNav(false);
        return;
      }
      this.toggleGalleryNav(true);
      if (this.slider && this.gallerySlideCount !== slideCount) {
        this.removeSlider();
      }
      this.gallerySlideCount = slideCount;
      if (!this.slider && ($s.media.isSmall || this.desktopStyle == 'carousel')) {
        this.initSlider();
      } else if (this.slider) {
        this.slider.refresh();
      }
    }

    onMediaChange() {
      if($s.media.isSmall || this.desktopStyle=='carousel') {
        this.syncGallerySlider();
      } else {
        this.removeSlider();
        this.toggleGalleryNav(false);
      }
    }

    initSlider() {
      var slideCount = this.getVisibleSlideCount();
      if (slideCount <= 1) {
        this.removeSlider();
        this.toggleGalleryNav(false);
        return;
      }
      this.toggleGalleryNav(true);

      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll('.media-wrap').forEach((slide)=>{
          if (slide.style.display !== 'none') {
            slide.classList.add('keen-slider-slide');
          } else {
            slide.classList.remove('keen-slider-slide');
          }
        });

        var slideCount = this.getVisibleSlideCount();
        this.gallerySlideCount = slideCount;

        var gallerySpacing = 16;

        var breakpoints = {};
        if(this.mobileStyle=='carousel') {
          breakpoints['(max-width: '+window.breakpoints.small+')'] = {
            slidesPerView: 1,
            spacing: gallerySpacing
          }
        }
        var prevArrow = this.querySelector('.keen-arrow.prev');
        var nextArrow = this.querySelector('.keen-arrow.next');

        var dotsElement = this.querySelector('.keen-dots');
        var keenSliderOptions = {
          mode: "snap",
          loop: slideCount > 2,
          wheel: false,
          spacing: gallerySpacing,
          prevButton: prevArrow || false,
          nextButton: nextArrow || false,
          pageInfo: this.querySelector('.keen-slider-page'),
          slideChanged: (keen)=>{
            $s.pauseAllMedia(this);
            let canPlay = true;
            if (this.autoplayOptionsElement) {
              this.autoplayOptionsElement.classList.remove('visible');
            }
            if (this.videoAutoplay) {
              const media = keen.currentSlide().querySelector('.media');
              if (this.autoplayOptionsElement && media) { // && media is to only show the checkbox on video slides.
                this.autoplayOptionsElement.classList.add('visible');
                //TODO eval  checkbox
                this.autoplayCheck.checked = canPlay = Cookies.get('autoplay')!='disabled';
              }
              if (media && canPlay) {
                $s.playMedia(media);
              }
            }
            this.dispatchEvent(new CustomEvent('slideChanged', {detail: keen}));
          },
          breakpoints
        };
        if (dotsElement) {
          keenSliderOptions.dots = dotsElement;
        }
        this.slider = new KeenSlider(this.itemsWrapper, keenSliderOptions);
      }
    }
  }
  customElements.define('product-gallery', ProductGallery);

  class ProductThumbs extends ProductMedia {
    constructor() {
      super();
      this.mainGallery = this.mainElement.querySelector('product-gallery');

      this.querySelectorAll('[data-media-id]').forEach((media)=>{
        media.addEventListener('click', (e)=>{
          this.mainGallery.showItem(media.dataset.mediaId);
        });
      });

      this.mainGallery.addEventListener('slideChanged', (e)=>{
        var currentSlide = e.detail.currentSlide();
        if(currentSlide) {
          var currentMediaId = currentSlide.dataset.mediaId;
          var currentSlideElement = this.querySelector('.current-slide');
          if(currentSlideElement) {
            currentSlideElement.classList.remove('current-slide');
          }
          this.querySelector('[data-media-id="'+currentMediaId+'"]').classList.add('current-slide');
          this.showItem(currentMediaId);
        }
      });
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant)
      }
    }

    onMediaChange() {
      if ($s.media.isSmall && this.mobileStyle.indexOf('thumbnails')>-1) {
        this.style.display = 'block';
        this.initSlider();
      } else {
        this.style.display = 'none';
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll('.thumb-wrap').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });
        var breakpoints = {};
        breakpoints['(max-width: '+window.breakpoints.medium+')'] = {
          slidesPerView: 4,
          spacing: 10,
          centered: false,
          ...(this.mobileStyle=='thumbnails_vertical' ? {
            vertical: true
          } : {vertical: false})
        }
        breakpoints['(max-width: '+window.breakpoints.small+')'] = {
          slidesPerView: 5,
          spacing: 10,
          centered: false,
          ...(this.mobileStyle=='thumbnails_vertical' ? {
            vertical: true
          } : {vertical: false})
        }
        this.slider = new KeenSlider(this.itemsWrapper, {
          mode: "snap",
          loop: true,
          centered: false,
          slidesPerView: 7,
          spacing: 15,
          prevButton: this.querySelector('.keen-arrow.prev'),
          nextButton: this.querySelector('.keen-arrow.next'),
          breakpoints,
          ...(this.desktopOrientation=='vertical' ? {
            vertical: true,
            slidesPerView: 5
          } : {})
        });
      }
    }
  }
  customElements.define('product-thumbs', ProductThumbs);
}

if(!customElements.get('product-price')) {
  class ProductPrice extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.finalPriceElement = this.querySelector('.final');
      this.comparePriceElement = this.querySelector('.compare');
      this.multiplyQuantity = typeof(this.dataset.multiplyQuantity)!='undefined' ? this.dataset.multiplyQuantity=='true' : false

      if(this.mainElement.classList.contains('product-card')){
        var originalPricePrefix = '<span class="visually-hidden">'+lngg.product__original_price_label+': </span>'
        var finalPricePrefix = '<span class="visually-hidden">. '+lngg.product__final_price_label+': </span>'
      }else{
        var originalPricePrefix = '<span class="visually-hidden">'+lngg.product__original_price_label+': </span>'
        var finalPricePrefix = '<span class="visually-hidden">. '+lngg.product__final_price_label+': </span>'
      }

      this.listenEvents = ['variantChange','sellingPlanChange'];
      if (this.multiplyQuantity)
        this.listenEvents.splice(1, 0, 'quantityChange');

      this.listenEvents.forEach((event)=>{
        this.mainElement.addEventListener(event, (e)=>{
          var data = this.mainElement.getCurrentPlan() || this.mainElement.getCurrentVariant();
          var quantity = this.multiplyQuantity ? this.mainElement.getQuantity() : 1;
          if (data) {
            this.finalPriceElement.innerHTML = $s.formatMoney(data.price * quantity).replace('.00','');

            if (this.comparePriceElement && data.compare_at_price > data.price) {
              this.comparePriceElement.classList.remove('hide');
              this.comparePriceElement.innerHTML = originalPricePrefix + $s.formatMoney(data.compare_at_price * quantity).replace('.00','');
              this.finalPriceElement.innerHTML = finalPricePrefix + $s.formatMoney(data.price * quantity).replace('.00','');
            } else if (this.comparePriceElement) {
              this.comparePriceElement.classList.add('hide');
              this.comparePriceElement.innerHTML = '';
            }
          } else {
            this.finalPriceElement.innerHTML = '';
            if (this.comparePriceElement) {
              this.comparePriceElement.innerHTML = '';
            }
          }
          var priceDetail = data ? data.price * quantity : 0;
          this.mainElement.dispatchEvent(new CustomEvent('priceChange', {detail: {price: priceDetail}}));
        });
      });
    }
  }
  customElements.define('product-price', ProductPrice);
}

if(!customElements.get('product-variants')) {
  class ProductVariants extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.mainElement.variantsInstances = (this.mainElement.variantsInstances || 0) +1;
      this.instanceIndex = this.mainElement.variantsInstances;
      this.variantInput = this.querySelector('[data-variant-id]');
      this.options = this.querySelectorAll('[data-option]');
      this.swatchImg = this.querySelector('product-swatch[data-use-img="true"]');
      this.variantsInfo = this.dataset.info ? JSON.parse(this.dataset.info) : null;
      this.swatchesImages = null;
      if (this.dataset.swatchesImages) {
        try {
          this.swatchesImages = JSON.parse(this.dataset.swatchesImages);
        } catch (err) {
          this.swatchesImages = null;
        }
      }
      this.mainElement.addEventListener('variantChange', (event)=> {
        if (this.variantInput.value != event.detail.variant.id) {
          this.setVariant(event.detail.variant);
        }
      })
      this.combinedListingOptions = [];
      
        this.mainElement.productData.options_with_values.forEach((option, index) => {
          let skipThisOption = false;
          for (let i = 0; i < option.values.length; i++) {
            if (!this.mainElement.productData.variants.some(v => v.options[index] == option.values[i].value)) {
              this.combinedListingOptions.push(option);
              break;
            }
          }
        })
      

      this.bindOptions();
      setTimeout(()=>{
        this.variantChange(this.getCurrentVariant(), false);
        this.bindInfoElements();
      }, 10);
    }

    getOptionInfo(optionName) {
      return (this.variantsInfo ? this.variantsInfo.find(x=>x.title==optionName) : null) || {};
    }

    getOptionInfoIcon(optionName) {
      var info = this.getOptionInfo(optionName);
      var html = '';
      if (info.description) {
        html = `
          <div class="option-info-icon">
            <button type="button" class="btn-open">?</button>
            <div class="option-info-content animation">${info.description}</div>
          </div>
        `;
      }

      return html;
    }
    getOptionInfoLink(optionName) {
      var info = this.getOptionInfo(optionName);
      var html = '';
      if (info.link_text) {
        if (info.link_target_image) {
          html = `
            <button type="button" class="option-info-link link" data-image-width="${info.link_target_image_native_width}" data-image-height="${info.link_target_image_native_height}" data-image="${info.link_target_image}" data-width="${info.link_target_image_width}">${info.link_text}</button>
          `;
        } else {
          html = `
            <a class="option-info-link link" href="${info.link_target_url}" target="_blank">${info.link_text}</a>
          `;
        }

      }

      return html;
    }

    getSwatchImage(value) {
      if (!this.swatchesImages || value == null || value === '') {
        return null;
      }
      var row = this.swatchesImages.find(function (x) {
        return x.title === value;
      });
      if (!row || !row.option_swatch_image) {
        return null;
      }
      var img = row.option_swatch_image;
      return typeof img === 'string' ? img : (img.src || null);
    }

    getCurrentVariant() {
      return this.mainElement.productData.variants.find(x=>x.id==this.variantInput.value)
    }

    setVariant(variant) {
      if(typeof variant !== 'object') {
        variant = this.mainElement.productData.variants.find(x=>x.id==variant);
      }
      if(variant) {
        this.refreshOptions(-1, variant);
        this.variantChange(variant);
      }
    }

    variantChange(variant, animate=true) {
      if(variant) {
        this.variantInput.value = variant.id;
        
      } else {
        this.variantInput.value = '';
      }
      this.previousVariant = variant;
      this.variantInput.dispatchEvent(new Event('change', {bubbles: true}));
      this.mainElement.dispatchEvent(new CustomEvent('variantChange', {detail: {variant, animate}}));

      if (this.swatchImg) {
          //var variant = this.mainElement.productData.variants.
          var optionIndex = this.swatchImg.dataset.option/1 -1;
          this.swatchImg.querySelectorAll('[type="radio"]').forEach(radio=>{
            var label = radio.parentNode.querySelector('.label-inner');
            
            var matchingVariant = this.mainElement.productData.variants.find(v => {
              if (v.options[optionIndex] !== radio.value) return false;
              // All other options must match the current variant
              for (let i = 0; i < v.options.length; i++) {
                if (i === optionIndex) continue;
                if (v.options[i] !== variant.options[i]) return false;
              }
              return true;
            });
            if (!matchingVariant) {
              matchingVariant = this.mainElement.productData.variants.find(
                v => v.options[optionIndex] == radio.value
              );
            }
            let img = label.querySelector('img');
            if (matchingVariant.featured_media) {
              if (!img) {
                img = document.createElement('img');
                img.loading = 'lazy';
                img.width = 80;
                img.height = 80;
                img.alt = '';
                label.appendChild(img);
              }
              img.src = $s.imgUrlFilter(matchingVariant.featured_media.src, '80x');
              img.style.display = '';
            } else {
              if (img) {
                img.style.display = 'none';
              }
            }
          });

      }

    }

    calculateNewVariant(optionChanged, value) {
      var newVariants = this.mainElement.productData.variants;
      this.mainElement.productData.options_with_values.forEach((option, index)=>{
        if(optionChanged==index) {
          newVariants = newVariants.filter(x=>x.options[index]==value);
        } else {
          var tmpNewVariants = this.previousVariant ? newVariants.filter(x=>x.options[index]==this.previousVariant.options[index]) : [];
          if(tmpNewVariants.length==0) {
            tmpNewVariants = newVariants.filter(x=>x.options[index]==newVariants[0].options[index]);
          }
          newVariants = tmpNewVariants;
        }
      });
      return newVariants[0];
    }

    bindOptions() {
      this.options.forEach((element)=>{
        element.addEventListener('change', (e)=>{
          let optionIdx = element.dataset.option-1;
          let variant = this.calculateNewVariant(optionIdx, e.target.value);
          
            if (this.combinedListingHandle(variant, optionIdx, e)) {
              //is handled by combined listing when the new variant is from a different product
              //then do not refresh options, load a different PDP or sections
              return;
            }
          
          this.refreshOptions(element.dataset.option-1, variant);
          this.variantChange(variant);
        });
      });
    }

    
    combinedListingHandle(variant, optionIdx, e) {
      let productUrl = '';
      if (!variant) {
        let optionValue = this.mainElement.productData.options_with_values[optionIdx].values.find(x=>x.value==e.target.value);
        if (optionValue.product_url) {
          productUrl = optionValue.product_url;
        }
      } else if (variant.product_id != this.mainElement.productData.product_id) {
        productUrl = variant.product_url;
      }

      if (productUrl) {
        if (this.mainElement.productData.is_product_merge) {
          this.mainElement.saveMergeSwatchOrder();
        }location = productUrl;
          return true;}
      return false;
    }
    
    
    bindInfoElements() {
      this.options.forEach((element)=>{
        var infoIcon = element.querySelector('.option-info-icon');
        var infoLink = element.querySelector('button.option-info-link');
        if (infoIcon) {
          $s.initFloatingPanel({container: infoIcon});
        }
        if (infoLink) {
          infoLink.addEventListener('click', (e)=>{
            var imageWidthPX = parseFloat(getComputedStyle(document.documentElement).fontSize) * infoLink.dataset.width;
            var html = `
              <div class="option-info-popup-content scheme" style="width: ${infoLink.dataset.width}rem">
                <img alt="" src="${infoLink.dataset.image + (infoLink.dataset.image.indexOf('?')==-1 ? '?' : '&') + 'width='+imageWidthPX}" width="${infoLink.dataset.imageWidth}" height="${infoLink.dataset.imageHeight}" />
              </div>
            `;
            $s.openModal(html, 'option-info-popup');
          });
        }
      });
    }

    // Get values with availability that depends on previous options
    getOptionValues(currentVariant) {
      var options = [];
      var variants = this.mainElement.productData.variants;
      options = structuredClone(this.mainElement.productData.options_with_values.map(x=>x.values));
      options.forEach((values, index) => {
        
          /* when combined products feature is enabled the options_with_values first option contains the correct availability of values */
          if (index == 0 || index < this.combinedListingOptions.length) {
            return;
          }
        
        // Filter variants that match previous selections
        let filteredVariants = variants;
        for (let prev = 0; prev < index; prev++) {
          filteredVariants = filteredVariants.filter(
            v => v.options[prev] === currentVariant.options[prev]
          );
        }
        let retValues = [];
        values.forEach((valueObj) => {
          const matchingVariants = filteredVariants.filter(
            v => v.options[index] === valueObj.value
          );
          if (matchingVariants.length > 0) {
            valueObj.available = matchingVariants.some(v => v.available);
            retValues.push(valueObj);
          }
        })
        options[index] = retValues;
      });
      return options;
    }

    refreshOptions(updateOptionIndex=-1, currentVariant) {
      var optionValues = this.getOptionValues(currentVariant);
      this.options.forEach((element)=>{
        let index = element.dataset.option - 1;
        if(index > updateOptionIndex) {
          element.buildOptions(optionValues[index], currentVariant.options[index]);
        }
        var optionValueElement = element.querySelector('.option-value');
        if(optionValueElement) {
          optionValueElement.innerHTML = currentVariant.options[index];
        }
      });
    }
  }
  customElements.define('product-variants', ProductVariants);
}

if(!customElements.get('product-variant-edit')) {
  class ProductVariantEdit extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.toggles = this.querySelectorAll('.toggle');
      this.toggles.forEach(btn=>{btn.addEventListener('click', this.onToggle.bind(this))});
      this.editing = false;
    }
    onToggle() {
      this.editing = !this.editing;
      var divVariants = this.querySelector('.variants');
      var divInfo = this.querySelector('.info');
      if (this.editing) {
        $s.expand([divVariants]);
        this.toggles.forEach(btn=>{btn.classList.add('open')});
      } else {
        $s.collapse([divVariants]);
        this.toggles.forEach(btn=>{btn.classList.remove('open')});
      }
    }
  }
  customElements.define('product-variant-edit', ProductVariantEdit);
}

if(!customElements.get('product-swatch')) {
  class ProductSwatch extends HTMLElement {
  	constructor() {
      super();
      this.colorSwatchesOptions = ["Color"]
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.closest('product-variants') || this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;
      this.infoIcon = this.variantsElement.getOptionInfoIcon(this.label) || '';
      this.infoLink = this.variantsElement.getOptionInfoLink(this.label) || '';
      this.trimOptionsLimit = this.dataset.trimOptionsLimit ? parseInt(this.dataset.trimOptionsLimit) : null;
      this.setAttribute('aria-labelledby', `swatchgroup-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}`);

      this.buildOptionSelector();
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];
    	var optionElement = document.createElement('div');
      var mainElementId = this.mainElement.dataset.productId;
      var optionNameHandle = $s.handleize(this.label);
  		var html = `
        <div class="option-name small-label">
          ${this.infoIcon}
          <span id="${this.getAttribute('aria-labelledby')}">${this.label}: </span>
          <span aria-hidden="true" class="option-value">${defaultValue}</span>
          ${this.infoLink}
        </div>
        <div class="swatch-group flex flex-wrap"></div>
  		`;
  		this.innerHTML = html;
  		this.buildOptions(optionValues, defaultValue);
    }

    buildOptions(options, defaultValue) {
    	var html = '';
      if (options.length > 0) {
        this.setAttribute('role', 'radiogroup');
      }
      const isInteractive = !this.closest('[aria-hidden="true"]');
  		options.forEach((option, index)=>{
        var optionNameHandle = $s.handleize(this.label);
        var optionValueHandle = $s.handleize(option.value);
        var id = `swatch2-${this.optionNumber}-${$s.handleize(option.value)}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}`;
        var soldOut = (!option.available ? '<span class="visually-hidden"> (Sold Out)</span>' : '');
        var optionLabelParts = option.value.split('|');
        var swatchImageUrl = this.variantsElement.getSwatchImage(option.value);
        var swatchImgTag = swatchImageUrl
          ? '<img alt="" src="' + $s.escapeDomAttribute(swatchImageUrl) + '" width="40" height="40" loading="lazy" />'
          : '';
        
        if (!this.trimOptionsLimit || index < this.trimOptionsLimit) {
          html += `
            <div class="swatch" data-available="${option.available}">
              <input type="radio" id="${id}" name="swatch-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}" value="${$s.escapeDomAttribute(option.value)}" ${!isInteractive ? 'tabindex="-1"':''} />
              <label for="${id}">
                <div class="label-inner flex align-items-center justify-content-center animation ${this.colorSwatchesOptions.indexOf(this.label)>-1 ? 'color-'+optionValueHandle : ''} ${optionNameHandle}-${optionValueHandle}">
                  ${swatchImgTag}
                  <span>${optionLabelParts[0]}${soldOut}</span>
                  ${optionLabelParts[1] ? `<span class="option-discount">${optionLabelParts[1]}</span>` : ''}
                </div>
              </label>
            </div>
          `;
        } else if (index === this.trimOptionsLimit) {
          html += `<div class="swatch swatch-remaining">+${options.length - this.trimOptionsLimit} ${lngg.product_card__swatches_more}</div>`;
        }
  		});
  		var group = this.querySelector('.swatch-group');
  		group.innerHTML = html;

      if (this.required()) {
        this.setAttribute('data-required', 'true');
        group.addEventListener('change', ()=>{
          this.setAttribute('data-required', 'false');
          this.required(false);
        }, {once: true})
      } else {
        this.setAttribute('data-required', 'false');
        if(defaultValue && group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]')) {
          group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]').checked = true;
        } else {
          group.querySelector('input').checked = true;
        }
      }
    }
  }
  customElements.define('product-swatch', ProductSwatch);
}

if(!customElements.get('product-dropdown')) {
  class ProductDropdown extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.closest('product-variants') || this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;
      this.infoIcon = this.variantsElement.getOptionInfoIcon(this.label) || '';
      this.infoLink = this.variantsElement.getOptionInfoLink(this.label) || '';

      this.buildOptionSelector();

      if (this.required()) {
        var select = this.querySelector('select');
        this.setAttribute('data-required', 'true');
        select.addEventListener('change', ()=>{
          this.setAttribute('data-required', 'false');
          this.required(false);
          select.querySelector('[disabled]').remove();
        }, {once: true})
      }
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];

      var optionId = 's-' + this.mainElement.sectionId+'-option-'+this.optionNumber + '-' + this.variantsElement.instanceIndex;
      var optionElement = document.createElement('div');
      const isInteractive = !this.closest('[aria-hidden="true"]');
      var html = `
        <label class="option-name small-label" for="${optionId}">
        ${this.infoIcon}${this.label}: 
        ${this.infoLink}
        </label>
        <div class="field">
          <svg aria-hidden="true" class="icon icon-arrow-down" viewBox="0 0 32 32"><path class="stroke" d="M27,10,16,22,5,10"/></svg> 
          <select id="${optionId}" name="swatch-${optionId}" ${!isInteractive ? 'tabindex="-1"':''}></select>
        </div>
      `;
      this.innerHTML = html;
      this.buildOptions(optionValues, defaultValue);
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    buildOptions(options, defaultValue) {
    	var html = '';
      if (this.required()) {
  			html += `<option value="${defaultValue || ''}" disabled selected>${lngg.general__forms__select_option_label}</option>`;
      } else {
        this.setAttribute('data-required', 'false');
      }
  		options.forEach((option, index)=>{
  			let soldOut = (!option.available ? lngg.product_main__sold_out_option_value : '');
  			html += `<option value="${$s.escapeDomAttribute(option.value)}">${option.value}${soldOut}</option>`;
  		});
  		var select = this.querySelector('select');
  		select.innerHTML = html;

  		if(defaultValue) {
    		var newValueIndex = Array.from(select.options).findIndex(x=>x.value==defaultValue);
    		if(newValueIndex>=0) {
    			select.selectedIndex = newValueIndex;
    		}
  		}
    }
  }
  customElements.define('product-dropdown', ProductDropdown);
}

if(!customElements.get('product-model')) {
  class ProductModel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = document.querySelector('.product-main-element[data-product-id="'+this.dataset.productId+'"]');

      window.Shopify.loadFeatures([{
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXr.bind(this)
      }]);
    }

    setupShopifyXr() {
      if(!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', ()=>{
          this.setupShopifyXr();
        });
      } else {
        window.ShopifyXR.addModels(this.mainElement.productData.media.filter(x=>x.media_type=='model'));
        setTimeout(()=>{
          window.ShopifyXR.setupXRElements();
        }, 100);
      }
    }
  }
  customElements.define('product-model', ProductModel);
}

if(!customElements.get('product-sticky-panel')) {
  class ProductStickyPanel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.scrollHandler = $s.throttle(this.onScroll.bind(this), 50);
      this.positionElement = this.mainElement.querySelector('.product-sticky-panel-position-placeholder');
    }

    connectedCallback() {
      if (this.positionElement) {
        window.addEventListener('scroll', this.scrollHandler);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.scrollHandler);
    }

    onScroll(event) {
      var bounds = this.positionElement.getBoundingClientRect();
      if (bounds.bottom < 0) {
        if (!this.showing) {
          this.classList.add('open');
          this.showing = true;
        }
      } else {
        if (this.showing) {
          this.classList.remove('open');
          this.showing = false;
        }
      }

    }

  }
  customElements.define('product-sticky-panel', ProductStickyPanel);
}

if(!customElements.get('pickup-availability')) {
  class PickupAvailability extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');

      this.mainElement.addEventListener('variantChange', (e)=>{
        if(e.detail.variant && e.detail.variant.available) {
          this.fetchAvailability(e.detail.variant.id);
        } else {
          this.innerHTML = '';
        }
      });
    }

    fetchAvailability(variantId) {
      let rootUrl = routes.root_url;
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup_availability`;

      $s.get({
        url: variantSectionUrl,
        success: (data)=>{
          this.innerHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('.shopify-section').innerHTML;
          this.bindEvents();
        },
        error: ()=>{
          this.innerHTML = '';
        }
      });
    }

    bindEvents() {
      let button = this.querySelector('.pickup-popup-trigger');
      if(button) {
        button.addEventListener('click', ()=>{
          $s.openModal(this.querySelector('.pickup-availability-info'), 'pickup-availability-info-modal');
        });
      }
    }
  }
  customElements.define('pickup-availability', PickupAvailability);
}



//REF: FEATURE SELLING PLANS
if(!customElements.get('product-selling-plan')) {
  class ProductSellingPlan extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.input = this.querySelector('[name="selling_plan"]');
      this.inputFrequencyName = this.querySelector('[name="selling_plan_frequency"]');
      this.groupsContainer = this.querySelector('[data-groups]');
      this.plansContainer = null; //obtained after every group render
      this.textOnetime = this.dataset.textOnetime;
      this.textSubscribe = this.dataset.textSubscribe;
      this.textSubscribeSave = this.dataset.textSubscribeSave;
      this.textDeliveryFrequency = this.dataset.textDeliveryFrequency;
      this.combineGroups = true;
      this.multiplyQuantity = typeof(this.dataset.multiplyQuantity)!='undefined' ? this.dataset.multiplyQuantity=='true' : false
      this.mainElement.lastSelectedSellingPlanId = this.input.value || this.mainElement.productData.sellingPlanGroups[0]?.selling_plans[0].id;
      this.servingsAmountDefault = this.dataset.servingsAmount;
      this.servingsAmountPods = this.dataset.servingsAmountPods;
      this.podsCountMeta = parseFloat(this.dataset.podsCount);
      if (isNaN(this.podsCountMeta) || this.podsCountMeta <= 0) {
        this.podsCountMeta = 0;
      }
      this.benefitsLines = [];
      var benefitsScript = this.querySelector('script[type="application/json"][data-selling-plan-benefits]');
      if (benefitsScript && benefitsScript.textContent) {
        try {
          var parsedBenefits = JSON.parse(benefitsScript.textContent.trim());
          if (Array.isArray(parsedBenefits)) {
            var flatBenefits = [];
            parsedBenefits.forEach(function (b) {
              if (!b) {
                return;
              }
              String(b).split(/\r\n|\n|\r/).forEach(function (part) {
                var t = part.trim();
                if (t) {
                  flatBenefits.push(t);
                }
              });
            });
            this.benefitsLines = flatBenefits;
          }
        } catch (benefitsErr) {}
      }

      this.input.addEventListener('change', ()=>{
        this.mainElement.dispatchEvent(new CustomEvent('sellingPlanChange', {detail: {sellingPlan: this.getCurrentPlan()}}));
      });

      this.groupsContainer.addEventListener('click', (e)=>{
        if (e.target.closest('select')) {
          return;
        }
        var field = e.target.closest('.selling-plan-card-frequency-field');
        if (!field) {
          return;
        }
        var select = field.querySelector('select');
        if (!select || select.disabled) {
          return;
        }
        this.openFrequencySelect(select);
      });

      this.listenEvents = ['variantChange'];
      if (this.multiplyQuantity)
        this.listenEvents.push('quantityChange');

      this.listenEvents.forEach((event)=>{
        this.mainElement.addEventListener(event, (e)=>{
          this.groupsContainer.innerHTML = this.getGroupsHtml();
          const {sellingPlan, group} = this.getSellingPlanByIdWithGroup(this.input.value);
          var currentVariant = this.mainElement.getCurrentVariant();
          var useCombinedSubscribe = this.combineGroups || (currentVariant && currentVariant.selling_plan_allocations && currentVariant.selling_plan_allocations.length > 1);
          var groupId = '';
          if (group) {
            groupId = useCombinedSubscribe && !this.combineGroups ? 'subscribe' : this.getHandledGroupId(group.id);
          }
          let currentGroupInput = this.groupsContainer.querySelector('[name="purchase_option"][value="'+groupId+'"]');
          if (!currentGroupInput) {
            //default to another group or even the One Time purchase if this variant doesn't have Selling Plans available
            currentGroupInput = this.groupsContainer.querySelector('[name="purchase_option"]:not([value=""])') || this.groupsContainer.querySelector('[name="purchase_option"]');
          }
          let currentPlanSelect = currentGroupInput.closest('div').querySelector('select');

          const groupInputs = this.groupsContainer.querySelectorAll('[name="purchase_option"]');
          groupInputs.forEach(groupInput=>{
            const planSelect = groupInput.closest('div').querySelector('select');
            groupInput.addEventListener('change', (e)=>{
              this.updateSellingPlan(planSelect ? planSelect.value : '');
            })
            if (planSelect) {
              planSelect.addEventListener('change', (e)=>{
                this.updateSellingPlan(e.target.value);
              });
            }
          })

          currentGroupInput.checked = true;
          if (currentPlanSelect && sellingPlan) {
            for (let i = 0; i < currentPlanSelect.options.length; i++) {
              const option = currentPlanSelect.options[i];
              if (option.text == sellingPlan.name || option.value == sellingPlan.id) {
                currentPlanSelect.selectedIndex = i;
              }
            }
          }
          this.updateSellingPlan(currentPlanSelect ? currentPlanSelect.value : '');
          this.showSellingPlanDetails();
          this.renderBenefitsLists();
        });
      });
      
    }

    renderBenefitsLists() {
      var self = this;
      this.groupsContainer.querySelectorAll('.selling-plan-card-subscribe').forEach(function (card) {
        self.renderBenefitsForCard(card);
      });
    }

    renderBenefitsForCard(card) {
      var benefitCheckIcon = '';
      var iconTemplate = this.querySelector('template[data-selling-plan-benefit-check-icon]');
      if (iconTemplate) {
        benefitCheckIcon = iconTemplate.innerHTML.trim();
      }
      var ul = card.querySelector('[data-selling-plan-benefits-list]');
      if (!ul) {
        return;
      }
      if (!this.benefitsLines.length) {
        ul.hidden = true;
        ul.innerHTML = '';
        return;
      }
      var select = card.querySelector('[data-plans] select');
      var freq = '';
      if (select && select.options.length && select.selectedIndex >= 0) {
        freq = select.options[select.selectedIndex].text.trim();
      }
      ul.innerHTML = '';
      this.benefitsLines.forEach(function (line) {
        var text = String(line).replace(/\|\|FREQUENCY\|\|/g, freq);
        var li = document.createElement('li');
        li.className = 'selling-plan-card-benefit';
        var check = document.createElement('span');
        check.className = 'selling-plan-card-benefit-check';
        check.setAttribute('aria-hidden', 'true');
        check.innerHTML = benefitCheckIcon;
        var textSpan = document.createElement('span');
        textSpan.className = 'selling-plan-card-benefit-text';
        textSpan.textContent = text;
        li.appendChild(check);
        li.appendChild(textSpan);
        ul.appendChild(li);
      });
      ul.hidden = false;
    }

    getSellingPlanByIdWithGroup(id) {
      for (let i=0; id && i < this.mainElement.productData.sellingPlanGroups.length; i++) {
        const group = this.mainElement.productData.sellingPlanGroups[i];
        const sellingPlan = group.selling_plans.find(x=>x.id==id)
        if (sellingPlan) {
          return {sellingPlan, group}
        }
      }
      return {sellingPlan: null, group: null};
    }

    getHandledGroupId(groupId) {
      return this.combineGroups ? 'subscribe' : groupId;
    }

    parsePodCountFromText(text) {
      if (!text) {
        return 0;
      }
      var str = String(text);
      var podMatch = str.match(/(\d+)\s*Pods?\b/i);
      if (podMatch) {
        return parseInt(podMatch[1], 10) || 0;
      }
      if (/pod/i.test(str)) {
        var leadingNum = str.match(/^(\d+)/);
        if (leadingNum) {
          return parseInt(leadingNum[1], 10) || 0;
        }
      }
      return 0;
    }

    resolveServingsAmount() {
      var variant = this.mainElement.getCurrentVariant();
      var title = variant && variant.title ? variant.title : '';
      var defaultAmt = parseFloat(this.servingsAmountDefault);
      var podsAmt = parseFloat(this.servingsAmountPods);
      var base = (!isNaN(defaultAmt) && defaultAmt > 0) ? defaultAmt : 1;
      var podsSetting = (!isNaN(podsAmt) && podsAmt > 0) ? podsAmt : base;
      var podCount = this.parsePodCountFromText(title);
      if (!podCount && variant && variant.options) {
        for (var i = 0; i < variant.options.length; i++) {
          podCount = this.parsePodCountFromText(variant.options[i]);
          if (podCount) {
            break;
          }
        }
      }
      if (!podCount && this.podsCountMeta > 0) {
        podCount = this.podsCountMeta;
      }
      if (podCount > 0) {
        return podCount;
      }
      if (title.indexOf('24ct') !== -1) {
        return 24;
      }
      if (/Pods?\b/i.test(title)) {
        return podsSetting;
      }
      if (variant && variant.options) {
        for (var j = 0; j < variant.options.length; j++) {
          if (/Pods?\b/i.test(String(variant.options[j]))) {
            return podsSetting;
          }
        }
      }
      if (this.podsCountMeta > 0) {
        return podsSetting;
      }
      return base;
    }

    formatPerServingLine(unitPriceCents) {
      if (typeof lngg === 'undefined' || !lngg.product_main__price_per_serving_suffix) {
        return '';
      }
      var servings = this.resolveServingsAmount();
      var qtyInName = this.mainElement.getQuantityInVariantName();
      var denom = servings * qtyInName;
      if (!denom || denom <= 0) {
        return '';
      }
      var perServingCents = Math.floor(unitPriceCents / denom);
      var per = $s.formatMoney(perServingCents).replace('.00', '');
      return '<span class="price-per-serving p4"> ' + per + ' ' + lngg.product_main__price_per_serving_suffix + '</span>';
    }

    showSellingPlanDetails() {
      var currentVariant = this.mainElement.getCurrentVariant();
      if (!currentVariant || !currentVariant.selling_plan_allocations) {
        return;
      }
      var self = this;
      this.groupsContainer.querySelectorAll('.selling-plan-card-subscribe').forEach(function (card) {
        var planSelect = card.querySelector('[data-plans] select');
        if (!planSelect) {
          return;
        }
        var planAlloc = currentVariant.selling_plan_allocations.find(function (x) {
          return String(x.selling_plan_id) === String(planSelect.value);
        });
        if (!planAlloc) {
          return;
        }
        var quantity = self.multiplyQuantity ? self.mainElement.getQuantity() : 1;
        var hasCompare = planAlloc.compare_at_price && planAlloc.compare_at_price > planAlloc.price;
        var discount = hasCompare ? Math.round(100 - planAlloc.price / planAlloc.compare_at_price * 100) : 0;
        var heading = card.querySelector('[data-selling-plan-heading]');
        var compareEl = card.querySelector('[data-selling-plan-compare]');
        var priceEl = card.querySelector('[data-selling-plan-price]');
        var perEl = card.querySelector('[data-selling-plan-per]');
        var discountEl = card.querySelector('[data-selling-plan-discount]');
        if (heading) {
          heading.textContent = discount > 0 ? self.textSubscribeSave : self.textSubscribe;
        }
        if (compareEl) {
          if (hasCompare) {
            compareEl.hidden = false;
            compareEl.innerHTML = '<span class="visually-hidden">' + lngg.product__original_price_label + ': </span>' + $s.formatMoney(planAlloc.compare_at_price * quantity).replace('.00', '');
          } else {
            compareEl.hidden = true;
            compareEl.innerHTML = '';
          }
        }
        if (priceEl) {
          priceEl.innerHTML = '<span class="visually-hidden">' + lngg.product__final_price_label + ': </span>' + $s.formatMoney(planAlloc.price * quantity).replace('.00', '');
        }
        if (perEl) {
          perEl.innerHTML = self.formatPerServingLine(planAlloc.price);
        }
        if (discountEl) {
          if (discount > 0 && typeof lngg !== 'undefined' && lngg.product_main__selling_plan_discount_every_order) {
            discountEl.hidden = false;
            discountEl.textContent = lngg.product_main__selling_plan_discount_every_order.replace(/__P__/g, String(discount));
          } else {
            discountEl.hidden = true;
            discountEl.textContent = '';
          }
        }
      });
    }

    updateSellingPlan(sellingPlanId) {
      this.input.value = sellingPlanId;
      if (sellingPlanId) {
        this.mainElement.lastSelectedSellingPlanId = sellingPlanId;
        const {sellingPlan, group} = this.getSellingPlanByIdWithGroup(sellingPlanId);
        this.inputFrequencyName.value = sellingPlan.name;
      } else {
        this.inputFrequencyName.value = '';
      }
      this.syncFrequencySelectState();
      this.showSellingPlanDetails();
      this.renderBenefitsLists();
      this.input.dispatchEvent(new Event('change', {bubbles: true}));
    }

    syncFrequencySelectState() {
      if (!this.groupsContainer) {
        return;
      }
      this.groupsContainer.querySelectorAll('.selling-plan-card-subscribe').forEach(function (card) {
        var radio = card.querySelector('[name="purchase_option"]');
        var select = card.querySelector('[data-plans] select');
        if (!select) {
          return;
        }
        var isActive = radio && radio.checked;
        if (isActive) {
          select.removeAttribute('disabled');
          select.classList.add('enabled');
        } else {
          select.setAttribute('disabled', 'disabled');
          select.classList.remove('enabled');
        }
      });
    }

    openFrequencySelect(select) {
      select.focus({ preventScroll: true });
      if (typeof select.showPicker === 'function') {
        try {
          select.showPicker();
          return;
        } catch (pickerErr) {}
      }
      select.click();
    }

    getGroupsHtml() {
      var self = this;
      var showFrequency = false;
      var currentVariant = this.mainElement.getCurrentVariant();
      var html = '';
      var quantity = this.multiplyQuantity ? this.mainElement.getQuantity() : 1;

      if(!this.mainElement.productData.requiresSellingPlan) {
        let optionId = `plan-option-onetime-${this.mainElement.sectionId}`;
        let optionPrice = $s.formatMoney(currentVariant.price * quantity).replace('.00', '');
        let perServingOneTime = this.formatPerServingLine(currentVariant.price);
        let compareOneTime = '';
        if (currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price) {
          compareOneTime = `<span class="selling-plan-card-compare-at"><span class="visually-hidden">${lngg.product__original_price_label}: </span>${$s.formatMoney(currentVariant.compare_at_price * quantity).replace('.00', '')}</span>`;
        }
        html += `
          <div class="selling-plan-card selling-plan-card-onetime">
            <input class="radio-custom" type="radio" name="purchase_option" value="" id="${optionId}">
            <label class="selling-plan-card-label radio-custom-label" for="${optionId}">
              <span class="selling-plan-card-label-column">
                <span class="selling-plan-card-row">
                  <span class="selling-plan-card-title">${this.textOnetime}</span>
                  <span class="selling-plan-card-price-stack">
                    <div class="selling-plan-card-price-row">
                      ${compareOneTime}
                      <span class="selling-plan-card-price-current"><span class="visually-hidden">${lngg.product__final_price_label}: </span>${optionPrice}</span>
                    </div>
                    <span class="selling-plan-card-per-serving-wrap">${perServingOneTime}</span>
                  </span>
                </span>
              </span>
            </label>
          </div>
        `;
      }
      if(currentVariant && currentVariant.selling_plan_allocations && currentVariant.selling_plan_allocations.length) {
        var allocations = currentVariant.selling_plan_allocations;
        var useCombinedSubscribe = this.combineGroups || allocations.length > 1;
        var groupsPrinted = {};
        allocations.forEach(function(planAlloc, ix) {
          if ((useCombinedSubscribe && ix > 0) || groupsPrinted[planAlloc.selling_plan_group_id]) {
            return;
          }
          groupsPrinted[planAlloc.selling_plan_group_id] = true;

          const group = self.mainElement.productData.sellingPlanGroups.find(x=>x.id==planAlloc.selling_plan_group_id);
          if (!group) {
            return;
          }

          const groupId = self.getHandledGroupId(useCombinedSubscribe ? 'subscribe' : group.id);
          let optionId = `plan-option-${groupId}-${self.mainElement.sectionId}`;
          var benefitsLabel = (typeof lngg !== 'undefined' && lngg.product_main__selling_plan_benefits_label) ? lngg.product_main__selling_plan_benefits_label : '';
          var ariaBenefits = benefitsLabel ? ' aria-label="' + benefitsLabel.replace(/"/g, '&quot;') + '"' : '';
          html += `
            <div class="selling-plan-card selling-plan-card-subscribe">
              <input class="radio-custom" type="radio" name="purchase_option" value="${groupId}" id="${optionId}">
              <label class="selling-plan-card-label radio-custom-label" for="${optionId}">
                <span class="selling-plan-card-label-column">
                  <span class="selling-plan-card-row">
                    <span class="selling-plan-card-title-col">
                      <span class="selling-plan-card-title" data-selling-plan-heading></span>
                      <span class="selling-plan-card-discount-line p4" data-selling-plan-discount hidden></span>
                    </span>
                    <span class="selling-plan-card-price-stack">
                      <div class="selling-plan-card-price-row">
                        <span class="selling-plan-card-compare-at" data-selling-plan-compare hidden></span>
                        <span class="selling-plan-card-price-current" data-selling-plan-price></span>
                      </div>
                      <span class="selling-plan-card-per-serving-wrap" data-selling-plan-per></span>
                    </span>
                  </span>
                </span>
              </label>
              <div data-plans class="selling-plan-card-plans ${!showFrequency ? 'frequency-hidden' : ''}">${self.getPlansHtml(group, useCombinedSubscribe)}</div>
              <ul class="selling-plan-card-benefits" data-selling-plan-benefits-list hidden` + ariaBenefits + `></ul>
            </div>
          `;
        });
      }
      return html;
    }

    getPlansHtml(group, useAllAllocations) {
      //functionalities:
      // show or hide frequency dropdown when the One-Time option is selected
      // show a div with the frequency option when there is a single option but keep the <select> hidden
      //
      var currentVariant = this.mainElement.getCurrentVariant();
      var enabled = this.input.value!='';

      var html = '';
      var useCombinedList = useAllAllocations || this.combineGroups;
      const groupPlanAllocations = useCombinedList ? currentVariant.selling_plan_allocations : currentVariant.selling_plan_allocations.filter(x=>x.selling_plan_group_id==group.id);
      var isOneOption = groupPlanAllocations.length==1;
      var freqLabel = this.textDeliveryFrequency || '';
      var disabledAttr = enabled ? '' : ' disabled="disabled"';
      html = `<div class="selling-plan-card-frequency">
        <span class="selling-plan-card-frequency-label">${freqLabel}</span>
        <div class="field no-label selling-plan-card-frequency-field ${isOneOption ? 'hide' : ''}">
          <select aria-label="${freqLabel}" id="frequency-${currentVariant.id}" class="${enabled ? 'enabled' : ''}"${disabledAttr}>`;
      groupPlanAllocations.forEach((plan)=>{
        const {sellingPlan} = this.getSellingPlanByIdWithGroup(plan.selling_plan_id);
        if (!sellingPlan) {
          return;
        }
        html += `<option value="${sellingPlan.id}">${sellingPlan.name}</option>`;
      });
      html += `</select><svg aria-hidden="true" class="icon icon-arrow-down" viewBox="0 0 32 32"><path class="stroke" d="M27,10,16,22,5,10"></path></svg></div>
      </div>`;
      if (isOneOption) {
        var singlePlan = this.getSellingPlanByIdWithGroup(groupPlanAllocations[0].selling_plan_id).sellingPlan;
        var singlePlanName = singlePlan ? singlePlan.name : group.selling_plans[0].name;
        html += `<div class="selling-plan-card-single-name selling-plan-name">${singlePlanName}</div>`;
      }

      return html;
    }

    getCurrentPlan() {
      var currentVariant = this.mainElement.getCurrentVariant();
      if(currentVariant) {
        return currentVariant.selling_plan_allocations.find(x=>x.selling_plan_id==this.input.value);
      }
      return false;
    }

  }
  customElements.define('product-selling-plan', ProductSellingPlan);
}


(function() {
  function stripSheetsCellAttrs(node) {
    node.removeAttribute('aria-label');
    node.removeAttribute('aria-autocomplete');
    node.removeAttribute('aria-expanded');
    node.removeAttribute('role');
    node.removeAttribute('tabindex');
    node.removeAttribute('dir');
    node.removeAttribute('spellcheck');
    if (node.getAttribute('id') === '') {
      node.removeAttribute('id');
    }
  }

  function unwrapSheetsCell(node) {
    stripSheetsCellAttrs(node);
    var paragraph = document.createElement('p');
    while (node.firstChild) {
      paragraph.appendChild(node.firstChild);
    }
    var text = paragraph.textContent ? paragraph.textContent.replace(/\s+/g, ' ').trim() : '';
    if (!text) {
      node.remove();
      return;
    }
    node.replaceWith(paragraph);
  }

  function sanitizeSheetsDescriptionMarkup(container) {
    if (!container) {
      return;
    }
    container.querySelectorAll('.cell-input, [class*="cell-input"]').forEach(unwrapSheetsCell);
    container.querySelectorAll('div[aria-label], div[aria-autocomplete], [role="combobox"]').forEach(function(node) {
      var label = node.getAttribute('aria-label');
      if (!label || /^I\d+$/.test(label)) {
        unwrapSheetsCell(node);
      } else {
        stripSheetsCellAttrs(node);
      }
    });
  }

  function runProductDescriptionSanitize() {
    document.querySelectorAll('.main-description, .enhanced-description').forEach(sanitizeSheetsDescriptionMarkup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runProductDescriptionSanitize);
  } else {
    runProductDescriptionSanitize();
  }
  [500, 2000, 5000].forEach(function(delayMs) {
    window.setTimeout(runProductDescriptionSanitize, delayMs);
  });
})();
